import styled from "@emotion/styled";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";

export const SkeletonCard = styled(StyledAnimatedSkeleton)`
  height: 194px;
  width: 970px;
`;
